import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "welcome-container"
};
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [_createElementVNode("h1", null, "欢迎使用优签管家系统", -1)]))]);
    };
  }
});